export type TokenOrg = {
  uuid?: string;
  name?: string;
  type_name?: string;
  parent_uuid?: string | null;
};

// Decode organisation info from a JWT token (string only). Returns null on failure.
export const decodeOrgFromToken = (token?: string | null): TokenOrg | null => {
  if (!token) return null;
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    const json = JSON.parse(
      atob(payload.replace(/-/g, "+").replace(/_/g, "/")),
    ) as { organisation?: TokenOrg };
    return json.organisation || null;
  } catch {
    return null;
  }
};
